import machineTypeDocs from "../data/machine_type_docs.json";

const DOC_INDEX = new Map();

const buildDocIndex = () => {
	if (DOC_INDEX.size > 0) return;
	if (!Array.isArray(machineTypeDocs)) return;
	machineTypeDocs.forEach((doc) => {
		const locationId = doc?.LocationID;
		const serialNumber = doc?.SerialNumber;
		if (!locationId || !serialNumber) return;
		const key = `${locationId}::${serialNumber}`;
		if (!DOC_INDEX.has(key)) DOC_INDEX.set(key, doc);
	});
};

export const getMachineDocEntry = ({ locationId, serialNumber }) => {
	if (!locationId || !serialNumber) return null;
	buildDocIndex();
	const key = `${locationId}::${serialNumber}`;
	return DOC_INDEX.get(key) || null;
};

export const hasMachineExternalDoc = ({ locationId, serialNumber }) => {
	const entry = getMachineDocEntry({ locationId, serialNumber });
	return entry?.HasDoc === "Y";
};

export const buildExternalLoginUrl = ({ templateUrl, username, password }) => {
	if (!templateUrl || !username || !password) return "";
	return templateUrl
		.replace(/{{\s*amf_method_username\s*}}/g, encodeURIComponent(username))
		.replace(/{{\s*amf_method_pass\s*}}/g, encodeURIComponent(password));
};

export const buildExternalTargetUrl = ({ username, group, machine }) => {
	if (!username || !group || !machine) return "";
	const normalizedGroup = String(group).replace(/[ &]+/g, "-");
	return `https://amfmethod.com/Locations/${encodeURIComponent(username)}/${encodeURIComponent(normalizedGroup)}/${encodeURIComponent(String(machine))}`;
};

export const openExternalDocumentation = ({ loginUrl, targetUrl, targetWindow = null }) => {
	if (!loginUrl || !targetUrl) return false;
	const loginWindow = window.open(loginUrl, "_blank", "width=20,height=2");
	if (loginWindow) {
		setTimeout(() => {
			if (targetWindow && !targetWindow.closed) {
				targetWindow.location.href = targetUrl;
				targetWindow.focus?.();
			} else {
				const newTab = window.open(targetUrl, "_blank", "noopener,noreferrer");
				if (!newTab) {
					console.log("Popup blocked: unable to open target URL.");
				}
			}
			loginWindow.close();
		}, 2000);
	} else {
		if (targetWindow && !targetWindow.closed) {
			targetWindow.location.href = targetUrl;
			targetWindow.focus?.();
		} else {
			const newTab = window.open(targetUrl, "_blank", "noopener,noreferrer");
			if (!newTab) {
				console.log("Popup blocked: unable to open target URL.");
			}
		}
	}

	return true;
};
